import { useCallback, useState } from "react";
import { Delete } from "@mui/icons-material";
import {
  Box,
  Divider,
  Fade,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";

import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useTraining } from "../../contexts";

interface IProps {
  item: { trainingType: string; description: string };
  selectedDay: string;
  handleEdit: () => void;
}

const TrainingItem = (props: IProps) => {
  const { item, selectedDay, handleEdit } = props;
  const { handleDeleteTraining } = useTraining();
  const [deleteWarningIsOpen, setDeleteWarningIsOpen] = useState(false);

  const handleCloseTooltip = useCallback(() => {
    setDeleteWarningIsOpen(false);
  }, []);

  return (
    <Fade in timeout={1000} key={item.trainingType}>
      <Box>
        <Box sx={{ position: "relative", mt: 1 }}>
          <Box onClick={handleEdit}>
            <Typography>{item.trainingType}</Typography>
            <Typography
              sx={{
                fontSize: "0.875rem",
                opacity: 0.5,
                whiteSpace: "pre",
              }}
            >
              {item.description}
            </Typography>
          </Box>
          <ClickAwayListener onClickAway={handleCloseTooltip}>
            <div>
              <Tooltip
                title={`Tem certeza que deseja excluir?`}
                placement="top-end"
                arrow
                open={deleteWarningIsOpen}
                PopperProps={{
                  disablePortal: true,
                }}
                onClose={() => setDeleteWarningIsOpen(false)}
                disableFocusListener
                disableHoverListener
                disableTouchListener
              >
                <IconButton
                  size="large"
                  sx={{ position: "absolute", right: 0, bottom: 0 }}
                  onClick={() =>
                    deleteWarningIsOpen
                      ? handleDeleteTraining(selectedDay, item.trainingType)
                      : setDeleteWarningIsOpen(true)
                  }
                >
                  <Delete color={deleteWarningIsOpen ? "error" : "inherit"} />
                </IconButton>
              </Tooltip>
            </div>
          </ClickAwayListener>
        </Box>
        <Divider sx={{ mt: 1 }} />
      </Box>
    </Fade>
  );
};

export default TrainingItem;
